// store/socketStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OnboardingDataState {
  isStep1Complete: boolean;
  isStep2Complete: boolean;
  isStep3Complete: boolean;
  userData: Record<string, any>;
  storeData: Record<string, any>;
  isInitialized: boolean;
  setIsStep1Complete: (isComplete: boolean) => void;
  setIsStep2Complete: (isComplete: boolean) => void;
  setIsStep3Complete: (isComplete: boolean) => void;
  setUserData: (data: Record<string, any>) => void;
  setStoreData: (data: Record<string, any>) => void;
  setIsInitialized: (isInitialized: boolean) => void;
}

const useOnboardingData = create<OnboardingDataState>()(
  persist(
    (set) => ({
      isStep1Complete: false,
      isStep2Complete: false,
      isStep3Complete: true,
      userData: {},
      storeData: {},
      isInitialized: true,
      setIsStep1Complete: (isComplete) =>
        set(() => ({ isStep1Complete: isComplete })),
      setIsStep2Complete: (isComplete) =>
        set(() => ({ isStep2Complete: isComplete })),
      setIsStep3Complete: (isComplete) =>
        set(() => ({ isStep3Complete: isComplete })),
      setUserData: (data) => set(() => ({ userData: data })),
      setStoreData: (data) => set(() => ({ storeData: data })),
      setIsInitialized: (isInitialized) =>
        set(() => ({ isInitialized: isInitialized })),
    }),
    {
      name: 'onboarding-data', // Key in localStorage
      partialize: (state) => ({
        isStep1Complete: state.isStep1Complete,
        isStep2Complete: state.isStep2Complete,
        isStep3Complete: state.isStep3Complete,
        userData: state.userData,
        storeData: state.storeData,
        isInitialized: state.isInitialized,
      }),
    },
  ),
);

export default useOnboardingData;
